module.exports = __webpack_public_path__ + "static/media/Pista_CordaoAzul.0788e7de.png";